export default class PhysicalSampleEligibilityDiagnostics {

    public totalSamplesInStudio: number;
    public alreadyUpToDateCount: number;
    public unmatchedPcbValues: string[];

    constructor(data: { [key: string]: any }) {
        this.totalSamplesInStudio = data['totalSamplesInStudio'] ?? 0;
        this.alreadyUpToDateCount = data['alreadyUpToDateCount'] ?? 0;
        this.unmatchedPcbValues = data['unmatchedPcbValues'] ?? [];
    }
}
